(function () {
  document.addEventListener("DOMContentLoaded", hydrateEssenceProductGrids);

  function hydrateEssenceProductGrids() {
    hydrateCollectionGrid();
    hydrateHomeProductGrids();
    hydrateDepartmentGrids();
  }

  function hydrateCollectionGrid() {
    var grid = document.querySelector("[data-products-grid]");
    if (!grid || !hasPlaceholder(grid)) return;

    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    var handle = match && match[1] ? match[1] : "brands";
    fetchProducts("/collections/" + handle + "/products.json?limit=24").then(function (products) {
      if (products.length) grid.innerHTML = products.map(renderProductCard).join("");
    });
  }

  function hydrateHomeProductGrids() {
    var grids = Array.prototype.slice.call(document.querySelectorAll(".ff-home-products__grid"));
    grids.forEach(function (grid, index) {
      if (!hasPlaceholder(grid)) return;

      var section = grid.closest(".ff-home-products");
      var url = "/collections/brands/products.json?limit=12";
      if (section && section.classList.contains("ff-home-products--sale")) {
        url = "/collections/sale/products.json?limit=12";
      } else if (index > 1) {
        url = "/collections/sneakers/products.json?limit=12";
      }

      fetchProducts(url).then(function (products) {
        if (products.length) grid.innerHTML = products.slice(0, 12).map(renderProductCard).join("");
      });
    });
  }

  function hydrateDepartmentGrids() {
    var sections = Array.prototype.slice.call(document.querySelectorAll("[data-source-collection]"));
    sections.forEach(function (section) {
      var grids = Array.prototype.slice.call(section.querySelectorAll(".ff-product-grid, .ff-state-products, .ff-department-products"));
      var handle = section.getAttribute("data-source-collection");
      if (!handle) return;

      grids.forEach(function (grid) {
        if (!hasPlaceholder(grid)) return;
        fetchProducts("/collections/" + handle + "/products.json?limit=12").then(function (products) {
          if (products.length) grid.innerHTML = products.slice(0, 12).map(renderProductCard).join("");
        });
      });
    });
  }

  function fetchProducts(url) {
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.ok ? response.json() : { products: [] };
      })
      .then(function (data) {
        return data.products || [];
      })
      .catch(function () {
        return [];
      });
  }

  function hasPlaceholder(node) {
    return node.querySelector(".ff-placeholder, .ff-image-placeholder") && !node.querySelector(".ff-product-card__title");
  }

  function renderProductCard(product) {
    var image = product.images && product.images[0] ? product.images[0].src : "";
    var imageSrc = shopifyImageUrl(image, 720);
    var imageSrcset = shopifyImageSrcset(image, [240, 360, 480, 600, 720]);
    var variant = product.variants && product.variants[0] ? product.variants[0] : {};
    var price = variant.price ? formatMoney(variant.price) : "";
    var compareAt = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)
      ? formatMoney(variant.compare_at_price)
      : "";
    var priceHtml = compareAt ? "<s>" + compareAt + "</s> <strong>" + price + "</strong>" : price;

    return [
      '<article class="ff-product-card">',
      '<a class="ff-product-card__media" href="/products/' + escapeHtml(product.handle) + '">',
      imageSrc
        ? '<img src="' + escapeHtml(imageSrc) + '" srcset="' + escapeHtml(imageSrcset) + '" sizes="(max-width: 749px) 58vw, 25vw" loading="lazy" decoding="async" width="720" height="960" alt="' + escapeHtml(product.title) + '">'
        : '<div class="ff-placeholder" aria-hidden="true"></div>',
      "</a>",
      '<a class="ff-product-card__info" href="/products/' + escapeHtml(product.handle) + '">',
      '<span class="ff-product-card__season">New Season</span>',
      product.vendor ? '<span class="ff-product-card__vendor">' + escapeHtml(product.vendor) + "</span>" : "",
      '<span class="ff-product-card__title">' + escapeHtml(product.title) + "</span>",
      '<span class="ff-product-card__price">' + priceHtml + "</span>",
      "</a>",
      "</article>"
    ].join("");
  }

  function shopifyImageUrl(url, width) {
    if (!url) return "";
    var separator = url.indexOf("?") === -1 ? "?" : "&";
    return url + separator + "width=" + width;
  }

  function shopifyImageSrcset(url, widths) {
    if (!url) return "";
    return widths.map(function (width) {
      return shopifyImageUrl(url, width) + " " + width + "w";
    }).join(", ");
  }

  function formatMoney(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return "";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: amount % 1 ? 2 : 0
    }).format(amount);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
})();
